<template>
    <section>
        <FbaBasketProduct
            v-for="fbaBasketProduct in _baskets"
            :key="fbaBasketProduct.id"
            :fba-basket-product="fbaBasketProduct"
        />
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'
    import FbaBasketProduct from '@/views/amazon/fba-basket/FbaBasket/FbaBasketProduct.vue'

    export default {
        name: 'FbaBasketProducts',
        components: {
            FbaBasketProduct,
        },
        computed: {
            ...mapGetters('azFbaBasket', ['_baskets']),
        },
    }
</script>
